export default "__VITE_ASSET__3943a4a1__"